module.exports = __webpack_public_path__ + "img/gravatar.fcdcc614.png";